import type { UniversalSearchResult } from '@/components/common/UniversalSearch/types';

type ItemData = {
  id: string;
  slug: string;
  category: string;
  link: string;
  isExternal?: boolean;
};

export const buildSearchItemData = (item: UniversalSearchResult): ItemData | undefined => {
  switch (item.__typename) {
    case 'AcademyArticleSearchResult':
      return {
        id: String(item.article.id),
        slug: item.article.slug,
        category: item.category,
        link: `/academy/${item.article.slug}`,
      };
    case 'CompanySearchResult':
      return {
        id: item.company.id,
        slug: item.company.slug ?? '',
        category: item.category,
        link: `/salaries/company/${item.company.slug}/`,
        isExternal: true,
      };
    case 'PortfolioUserSearchResult':
      return {
        id: item.portfolioUser.slug,
        slug: item.portfolioUser.slug,
        category: item.category,
        link: `/p/${item.portfolioUser.slug}`,
      };
    case 'WarRoomPostSearchResult':
      return {
        id: item.post.id,
        slug: item.post.slug,
        category: item.category,
        link: `/war-room/posts/${item.post.slug}`,
      };
    case 'WarRoomUserSearchResult':
      return {
        id: String(item.warRoomUser?.id),
        slug: String(item.warRoomUser?.username),
        category: item.category,
        link: `/war-room/profile/${item.warRoomUser?.username}`,
      };
  }
};
